export default "__VITE_ASSET__CFdeboLo__"